import React from "react";
import PropTypes from "prop-types";
import Util from "../Util";
import { Fragment } from "react";

const defaultProps = {
  email: {
    label: "das@osu.edu",
    "aria-label": "D.A.S. at O.S.U. dot E.D.U. (Digital Accessibility Services)",
    href: "mailto:das@osu.edu",
    id: 'footer-das-email-link'
  },
  phone: {
    label: "614-292-5000",
    href: "tel:614-292-5000",
    id: 'footer-das-phone-link'
  },
}

function Accessibility(props = {}) {
  const { className, email = defaultProps.email, phone = defaultProps.phone, ...rest } = props
  let classN = 'bux-footer__ada'
  if(className) classN += ` ${className}`
  return (
    <div className={classN} {...rest}>
      If you have a disability and experience difficulty accessing this content,
      please contact Digital Accessibility Services for assistance at{" "}
      {!!email?.href && <Util.Link {...email}>
        {email.label || email.href}
      </Util.Link>}{" "}
      {!!phone?.href && <Fragment>
        or{" "}
        <Util.Link id={phone?.id} href={phone.href}>
          {phone.label || phone.href}
        </Util.Link>
      </Fragment>}
      .
    </div>
  );
}
Accessibility.propTypes = {
  email: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
  phone: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default Accessibility;
